module.exports = __webpack_public_path__ + "img/g3.d73e006f.png";